export const hasCustomText = (input: HTMLDivElement) => {
  return (
    Array.from(input.childNodes).filter(
      (node) =>
        node.nodeType === Node.TEXT_NODE && node.textContent?.replaceAll(/@|#|\//g, "").trim(),
    ).length > 0
  );
};
